import { useState, useEffect } from "react";

const FOLDERS = [
  "AlertsNotifications",
  "Arrows",
  "Courses/CreditManagement",
  "Courses/LifeQuality",
  "Courses/MoneyManagement",
  "Documents",
  "Media",
  "Messaging",
  "Miscellaneous",
  "Password",
  "SocialMedia",
  "User",
];

const cache = new Map();

/**
 * Renderiza un componente de icono dinámicamente basado en el nombre del icono.
 * Busca a través de carpetas predefinidas y almacena resultados en caché para mejorar el rendimiento.
 *
 * @param {Object} props - Propiedades del componente
 * @param {string} props.iconName - Nombre del icono a cargar
 * @param {...*} props - Propiedades adicionales pasadas al componente de icono
 *
 * @returns {JSX.Element|null} El componente de icono renderizado o null si no se encuentra
 */
export const DynamicIcon = ({ iconName, ...props }) => {
  const [Icon, setIcon] = useState(null);

  useEffect(() => {
    if (!iconName) return;

    if (cache.has(iconName)) {
      setIcon(() => cache.get(iconName));
      return;
    }

    (async () => {
      for (const folder of FOLDERS) {
        try {
          const module = await import(`../Icons/${folder}/${iconName}.jsx`);
          const Component = module.default || module[iconName];
          if (Component) {
            cache.set(iconName, Component);
            setIcon(() => Component);
            return;
          }
        } catch {}
      }
      cache.set(iconName, null);
      setIcon(null);
    })();
  }, [iconName]);

  return Icon ? <Icon {...props} /> : null;
};
